import debugT from 'debug';
import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import $ from 'jquery';
import querystring from 'querystring';
import page from 'modules/ab-page-js';
import splash from './view/index.pug';
import metadata from './metadata.json';
import ContactForm from 'auth0-contact-form';

import UniversalLogin from './components/UniversalLogin';

const metricsLib = window.metricsLib;

let unmountUniversalLoginApp = () => {};

export default function register() {
  page('/universal-login', initial, snippets);

  page.exit('/universal-login', unMountApp);
}

function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  render(<UniversalLogin />, document.getElementById('js-universal-login-app'));

  return next();
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  const $ = window.$;

  contactFormModals();

  next();
}

/**
 *  // Contact Sales Form
 */
function contactFormModals() {
  const salesContactFormOptions = {
    onModalOpen() {
      window.metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      window.metricsLib.track('register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitSuccess('#contact-form-modal__form');
    },
    onFormFail(metricsData) {
      window.metricsLib.track('fail:register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitFailure('#contact-form-modal__form');
    },
    source: 'home-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const ttsMetadata = { place: 'banner', type: 'button', text: 'talk to sales' };
  $('.open-contact-form-modal').click(() => metricsLib.track('click:contact-sales', { trackData: { ...ttsMetadata } }, () => window.location.assign(`/contact-us?${querystring.stringify(ttsMetadata)}`)));
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.getElementById('js-universal-login-app'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/universal-login/client.js